export default "__VITE_ASSET__DdOIzt8J__"